import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { endpointsURL } from "../constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class PatronesWltpService {
  env = environment.env;
  maintenancePatronWltpURL = endpointsURL.maintenancePatronWltpURL;

  constructor(private httpClient: HttpClient) {}

  public getPatronWltpLista(filters: string): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.maintenancePatronWltpURL}/lista${filters}`
    );
  }

  public getpatronWltpEdit(filter: string): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.maintenancePatronWltpURL}${filter}`
    );
  }
}
